import { Building2, Landmark, Plane, Umbrella } from "lucide-react";

export const popularLocations = [
  {
    address_components: [
      {
        long_name: "no.162",
        short_name: "no.162",
        types: ["street_number"],
      },
      {
        long_name: "Jalan Bypass Ngurah Rai",
        short_name: "Jl. Bypass Ngurah Rai",
        types: ["route"],
      },
      {
        long_name: "Sanur Kaja",
        short_name: "Sanur Kaja",
        types: ["administrative_area_level_4", "political"],
      },
      {
        long_name: "Kecamatan Denpasar Selatan",
        short_name: "Kec. Denpasar Sel.",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Kota Denpasar",
        short_name: "Kota Denpasar",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
      {
        long_name: "80227",
        short_name: "80227",
        types: ["postal_code"],
      },
    ],
    formatted_address:
      "Jl. Bypass Ngurah Rai No.162, Sanur Kaja, Denpasar Selatan, Kota Denpasar, Bali 80227, Indonesia",
    geometry: {
      location: {
        lat: -8.6755677,
        lng: 115.2590742,
      },
      viewport: {
        south: -8.676948130291501,
        west: 115.2578341197085,
        north: -8.674250169708499,
        east: 115.2605320802915,
      },
    },
    name: "Wirasana Rent A Car",
    place_id: "ChIJ2XFOmkdA0i0Rmt1g0SGS7Z0",
    url: "https://maps.google.com/?cid=11379912507379473818",
    html_attributions: [],
    icon: Building2,
    type: "Office",
  },
  {
    address_components: [
      {
        long_name: "Jalan Airport Ngurah Rai",
        short_name: "Jl. Airport Ngurah Rai",
        types: ["route"],
      },
      {
        long_name: "Tuban",
        short_name: "Tuban",
        types: ["administrative_area_level_4", "political"],
      },
      {
        long_name: "Kecamatan Kuta",
        short_name: "Kec. Kuta",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Kabupaten Badung",
        short_name: "Kabupaten Badung",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
      {
        long_name: "80361",
        short_name: "80361",
        types: ["postal_code"],
      },
    ],
    formatted_address: "Jl. Airport Ngurah Rai, Tuban, Kec. Kuta, Kabupaten Badung, Bali 80361, Indonesia",
    geometry: {
      location: {
        lat: -8.7469933,
        lng: 115.1681655,
      },
      viewport: {
        south: -8.7483588,
        west: 115.1614961,
        north: -8.740382199999999,
        east: 115.1715576,
      },
    },
    name: "I Gusti Ngurah Rai International Airport",
    place_id: "ChIJM2khUBZE0i0RH8x73W3acd8",
    url: "https://maps.google.com/?cid=16100890308228402207",
    html_attributions: [],
    icon: Plane,
    type: "Airport",
  },
  {
    address_components: [
      {
        long_name: "Kuta Beach",
        short_name: "Kuta Beach",
        types: ["establishment", "natural_feature"],
      },
      {
        long_name: "Kuta",
        short_name: "Kuta",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Badung Regency",
        short_name: "Badung Regency",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
    ],
    formatted_address: "Kuta Beach, Kuta, Badung Regency, Bali, Indonesia",
    geometry: {
      location: {
        lat: -8.7184926,
        lng: 115.1686322,
      },
      viewport: {
        south: -8.726963037511597,
        west: 115.1663844563331,
        north: -8.709102134826704,
        east: 115.1698601,
      },
    },
    name: "Kuta Beach",
    place_id: "ChIJQw23KrxG0i0RjrRKL-Gq_oI",
    url: "https://maps.google.com/?cid=9439169753152926862",
    html_attributions: [],
    type: "Beach",
    icon: Umbrella,
  },
  {
    address_components: [
      {
        long_name: "Ubud",
        short_name: "Ubud",
        types: ["locality", "political"],
      },
      {
        long_name: "Ubud",
        short_name: "Ubud",
        types: ["administrative_area_level_4", "political"],
      },
      {
        long_name: "Ubud",
        short_name: "Ubud",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Gianyar Regency",
        short_name: "Gianyar Regency",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
    ],
    formatted_address: "Ubud, Gianyar Regency, Bali, Indonesia",
    geometry: {
      location: {
        lat: -8.5068536,
        lng: 115.2624778,
      },
      viewport: {
        south: -8.523332932377631,
        west: 115.2545929699809,
        north: -8.46888942657574,
        east: 115.277485941939,
      },
    },
    name: "Ubud",
    place_id: "ChIJw8kin3M90i0RHD13a_2Ko1Q",
    url: "https://maps.google.com/?cid=6098871141424119068",
    html_attributions: [],
    type: "Cultural Area",
    icon: Landmark,
  },
  {
    address_components: [
      {
        long_name: "Beraban",
        short_name: "Beraban",
        types: ["administrative_area_level_4", "political"],
      },
      {
        long_name: "Kediri",
        short_name: "Kediri",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Tabanan Regency",
        short_name: "Tabanan Regency",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
      {
        long_name: "82121",
        short_name: "82121",
        types: ["postal_code"],
      },
    ],
    formatted_address: "Beraban, Kediri, Tabanan Regency, Bali 82121, Indonesia",
    geometry: {
      location: {
        lat: -8.621213,
        lng: 115.086807,
      },
      viewport: {
        south: -8.622560830291503,
        west: 115.0854541697085,
        north: -8.619862869708498,
        east: 115.0881521302915,
      },
    },
    name: "Tanah Lot",
    place_id: "ChIJq95xT4I30i0RaU3j93Diq8o",
    url: "https://maps.google.com/?cid=14604015191502048617",
    html_attributions: [],
    type: "Temple",
    icon: Landmark,
  },
  {
    address_components: [
      {
        long_name: "Jalan Cemara",
        short_name: "Jalan Cemara",
        types: ["route"],
      },
      {
        long_name: "Sanur",
        short_name: "Sanur",
        types: ["administrative_area_level_4", "political"],
      },
      {
        long_name: "Kecamatan Denpasar Selatan",
        short_name: "Kec. Denpasar Sel.",
        types: ["administrative_area_level_3", "political"],
      },
      {
        long_name: "Kota Denpasar",
        short_name: "Kota Denpasar",
        types: ["administrative_area_level_2", "political"],
      },
      {
        long_name: "Bali",
        short_name: "Bali",
        types: ["administrative_area_level_1", "political"],
      },
      {
        long_name: "Indonesia",
        short_name: "ID",
        types: ["country", "political"],
      },
    ],
    formatted_address: "Jalan Cemara, Sanur, Denpasar Selatan, Kota Denpasar, Bali, Indonesia",
    geometry: {
      location: {
        lat: -8.673641,
        lng: 115.2634709,
      },
      viewport: {
        south: -8.6749570802915,
        west: 115.2620116197085,
        north: -8.672259119708496,
        east: 115.2647095802915,
      },
    },
    name: "Sanur Beach",
    place_id: "ChIJkxyL4dhB0i0RQ23bDDD-rus",
    url: "https://maps.google.com/?cid=16982790727188311363",
    html_attributions: [],
    type: "Beach",
    icon: Umbrella,
  },
];
